import Skeleton from '../Skeleton'

interface Props {
  className?: string
  skeletonClassName?: string
}

const SkeletonLoader = ({ className, skeletonClassName }: Props) => {
  return (
    <>
    <Skeleton className={`!rounded-2xl h-[50px] w-full overflow-hidden mb-[10px]`} />
    <div className={`grid grid-cols-2 ${className}`}>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
      <SkeletonCard skeletonClassName={skeletonClassName}/>
    </div>
    </>
  )
}

const SkeletonCard = ({ skeletonClassName }: { skeletonClassName?: string }) => {
  return <Skeleton className={`!rounded-2xl h-[376px] w-full overflow-hidden ${skeletonClassName ?? ''}`} />
}

export default SkeletonLoader
